import { Routes } from '@angular/router';
import { SSOFormCapNhatThongTin } from './require-update-info.component';
import { SSOErrorViewComponent } from './components/error-view/error-view.component';

export const routes: Routes = [
  {
    // Form handle navigation to specific bussiness logic
    path: '',
    component: SSOFormCapNhatThongTin,
  },
  {
    path: 'loi-ngoai-le', // Error when get fisrt info
    component: SSOErrorViewComponent,
  },
];
